import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SAVE_FILTER, UPDATE_FILTER } from './constants/filter-config.constant';

@Injectable({ providedIn: 'root' })
export class FilterConfigService {
    public editSubject = new Subject<any>();
    selectedInboxListUpdate = new Subject<any>();

    constructor() {}

    defaultList = ['tasks', 'signals', 'recovery'];
    selectedInboxListUpdate$ = this.selectedInboxListUpdate.asObservable();
    dropdownIconClass = 'pi pi-chevron-down';
    dropDownActions = [
        {
            defaultLabel: 'default-cm-updateExistingFilter',
            label: UPDATE_FILTER,
        },
        {
            defaultLabel: 'default-cm-saveFilter',
            label: SAVE_FILTER,
        },
    ];
    editSubject$ = this.editSubject.asObservable();
}
